/**
 * Opens the 3D flyover from a Datastar page. The button names the element holding the route the
 * server sent (data-flyover-route) and the flyover module to load (data-flyover-module, from
 * assets.FlyoverJSPath); the module only downloads the first time a flyover opens.
 */

import { showToast } from './toast';

export async function openFlyover(button: HTMLElement): Promise<void> {
    const source = document.getElementById(button.dataset.flyoverRoute ?? '');
    const modulePath = button.dataset.flyoverModule;
    if (!source?.textContent?.trim() || !modulePath) {
        showToast('The route is still loading', 'error');
        return;
    }
    try {
        const flyover = (await import(modulePath)) as typeof import('./flyover/main');
        flyover.openFlyover(JSON.parse(source.textContent));
    } catch (err) {
        console.error('flyover_failed', err);
        showToast('The flyover could not start', 'error');
    }
}
